import {
	EPIC_COLOR_TYPE,
	REPORTER_TYPE,
	ASSIGNEE_TYPE,
	MESSAGE_EDIT_CF_TYPE,
	PARENT_FIELD_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import {
	RICH_TEXT_FIELD,
	USER_PICKER_FIELD,
	COLOR_FIELD,
	ASSIGNEE_FIELD,
	REPORTER_FIELD,
	TEXT_AREA_FIELD,
	EPIC_COLOR_FIELD,
	CONNECT_RICH_TEXT_FIELD,
	MESSAGE_EDIT_FIELD,
	PARENT_LINK_FIELD,
	PARENT_FIELD,
} from '../../constants/graphql-field-types.tsx';
import type { OverriddenGqlTypes } from '../../types/context-fields.tsx';
import type { JiraIssueFieldUnion } from '../../types/create-config-query.tsx';

export const overrideGqlTypes = ({
	type,
	__typename: gqlType,
	renderer,
}: {
	type: string;
	__typename: JiraIssueFieldUnion['__typename'];
	renderer?: string;
}): JiraIssueFieldUnion['__typename'] | OverriddenGqlTypes => {
	if (gqlType === USER_PICKER_FIELD && type === ASSIGNEE_TYPE) {
		return ASSIGNEE_FIELD;
	}
	if (gqlType === USER_PICKER_FIELD && type === REPORTER_TYPE) {
		return REPORTER_FIELD;
	}
	if (gqlType === COLOR_FIELD && type === EPIC_COLOR_TYPE) {
		return EPIC_COLOR_FIELD;
	}
	if (gqlType === RICH_TEXT_FIELD && type === MESSAGE_EDIT_CF_TYPE) {
		return MESSAGE_EDIT_FIELD;
	}
	if (gqlType === RICH_TEXT_FIELD || gqlType === CONNECT_RICH_TEXT_FIELD) {
		return renderer === 'atlassian-wiki-renderer' ? RICH_TEXT_FIELD : TEXT_AREA_FIELD;
	}
	// we want to keep "JiraParentIssueField" jql name for PARENT_FIELD long term when PARENT_LINK_FIELD is depricated hence this override
	if (gqlType === PARENT_LINK_FIELD && type === PARENT_FIELD_TYPE) {
		return PARENT_FIELD;
	}
	return gqlType;
};
